import { motion } from "framer-motion";
import { useI18n } from "../../i18n/LanguageProvider";
import { Container } from "../Container";
import { Reveal } from "../Reveal";
import { Check } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export function Philosophy() {
  const { t } = useI18n();
  const points = t("philosophy.points");

  return (
    <section className="relative overflow-hidden bg-[#EAF7F0] py-32 md:py-40">
      <div className="pointer-events-none absolute -right-32 top-1/4 h-96 w-96 rounded-full bg-green/15 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-white/60 blur-3xl" />
      <Container>
        <div className="mx-auto max-w-4xl">
          <div className="mb-6 flex items-center gap-3">
            <span className="h-1.5 w-1.5 rounded-full brand-gradient" />
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-black/50">{t("philosophy.label")}</span>
          </div>
          <Reveal>
            <h2 className="text-3xl font-semibold leading-[1.12] tracking-tight text-black sm:text-4xl lg:text-[3.25rem]">
              {t("philosophy.title")}{" "}
              <span className="brand-text">{t("philosophy.titleGreen")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-black/55">{t("philosophy.text")}</p>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 gap-x-12 gap-y-4 sm:grid-cols-2">
            {points.map((p, i) => (
              <motion.div
                key={p}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease, delay: (i % 2) * 0.06 }}
                className="flex items-center gap-3 border-b border-black/[0.07] pb-4"
              >
                <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full brand-gradient text-white">
                  <Check strokeWidth={2.5} className="h-3.5 w-3.5" />
                </span>
                <span className="text-base font-medium tracking-tight text-black">{p}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
